import { Modal, darkColors } from '@tryhackme/thm-ui-components';
import { type FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider, useTheme } from 'styled-components';
import { useGetUserQuery } from 'src/common/slices';
import { useActiveCampaign } from '../../../hooks/use-active-campaign';
import { useCampaignCta } from '../../../hooks/use-campaign-cta';
import { useCampaignStorage } from '../../../hooks/use-campaign-storage';
import { useInfluencerSubscriptionAdditionalConfigs } from '../../hooks/use-influencer-additional-configs';
import { useInfluencerSubscriptionCampaign } from '../../hooks/use-influencer-campaign';
import { StyledContent, StyledInfluencerRedirectButton, StyledWrapper } from './influencer-subscription-campaign-modal.styles';
import type { InfluencerSubscriptionCampaignModalProps } from './influencer-subscription-campaign-modal.types';
export const InfluencerSubscriptionCampaignModal: FC<InfluencerSubscriptionCampaignModalProps> = ({
  influencerCampaign,
  content: Content
}) => {
  const theme = useTheme();
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const {
    campaign
  } = useActiveCampaign();
  const [ctaText, loggedUserUrlToNavigate] = useCampaignCta();
  const {
    isSeen,
    markAsSeen,
    reset
  } = useCampaignStorage(campaign);
  const [prevAuthState, setPrevAuthState] = useState(!!userDataResponse?.data);
  const [open, setOpen] = useState(!userDataResponse?.data || !isSeen);
  const {
    userFriendlyName
  } = useInfluencerSubscriptionCampaign(influencerCampaign);
  const additionalConfigs = useInfluencerSubscriptionAdditionalConfigs(campaign?.name);
  const {
    pagesToShowCTA,
    barCta,
    InfluencerIcon,
    urlToNavigate
  } = additionalConfigs ?? {};
  const url = userDataResponse?.data ? loggedUserUrlToNavigate : urlToNavigate;
  useEffect(() => {
    if (isSeen) {
      setOpen(false);
    }
  }, [isSeen]);
  useEffect(() => {
    const isLoggedIn = !!userDataResponse?.data;
    const wasLoggedIn = !!prevAuthState;
    if (isLoggedIn !== wasLoggedIn) {
      reset();
      setPrevAuthState(isLoggedIn);
    }
  }, [userDataResponse?.data, prevAuthState, reset]);
  const onOpenChange = (isOpen: boolean) => {
    if (isOpen) return;
    markAsSeen();
    setOpen(false);
  };
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="InfluencerSubscriptionCampaignModal" data-sentry-source-file="influencer-subscription-campaign-modal.tsx">
      <Modal padding="0" open={open} onOpenChange={onOpenChange} data-sentry-element="Modal" data-sentry-source-file="influencer-subscription-campaign-modal.tsx">
        <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-source-file="influencer-subscription-campaign-modal.tsx">
          <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="influencer-subscription-campaign-modal.tsx">
            {InfluencerIcon && <InfluencerIcon />}

            <Content campaign={campaign} userFriendlyName={userFriendlyName} data-sentry-element="Content" data-sentry-source-file="influencer-subscription-campaign-modal.tsx" />

            <StyledInfluencerRedirectButton as={Link} to={url ?? ''} role="button" variant="solid" color="primary" onClick={markAsSeen} data-sentry-element="StyledInfluencerRedirectButton" data-sentry-source-file="influencer-subscription-campaign-modal.tsx">
              {ctaText}
            </StyledInfluencerRedirectButton>
          </StyledContent>
        </StyledWrapper>
      </Modal>
    </ThemeProvider>;
};